
import { supabase } from '../client';
import { Shop } from './types';
import { generateUniqueSlug, generateSlugFromName, checkSlugExists } from './slugUtils';

export async function updateShop(shopId: string, shopData: Partial<Shop>): Promise<{ success: boolean; error?: any }> {
  try {
    if (!shopId) {
      console.error('[updateShop] No shop ID provided');
      return { success: false, error: 'No shop ID provided' };
    }
    
    const dataToUpdate = { ...shopData };
    
    if (dataToUpdate.name) {
      if (!dataToUpdate.slug) {
        dataToUpdate.slug = await generateUniqueSlug(dataToUpdate.name);
        console.log(`[updateShop] Slug unique généré: ${dataToUpdate.slug}`);
      } else if (dataToUpdate.slug !== generateSlugFromName(dataToUpdate.name)) {
        const slugExists = await checkSlugExists(dataToUpdate.slug);
        if (slugExists) {
          dataToUpdate.slug = await generateUniqueSlug(dataToUpdate.name);
          console.log(`[updateShop] Slug fourni existe déjà, nouveau slug généré: ${dataToUpdate.slug}`);
        }
      }
    }
    
    console.log(`[updateShop] Updating shop: ${shopId}`, dataToUpdate);
    
    const { data, error } = await supabase
      .from('shops')
      .update(dataToUpdate)
      .eq('id', shopId)
      .select()
      .single();

    if (error) {
      console.error('[updateShop] Error updating shop:', error);
      return { success: false, error };
    }

    console.log(`[updateShop] Shop updated successfully:`, data);
    return { success: true };
  } catch (error) {
    console.error('[updateShop] Exception in updateShop:', error);
    return { success: false, error };
  }
}
